import React, { useContext, useState, useEffect } from 'react';
import { Paper , TextField , Box , IconButton} from '@mui/material';
import { Row, Col } from 'react-bootstrap';
import ApiService from '../../functions/apiService';
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import { toast } from 'react-toastify';
import { PhotoCamera, Close } from '@mui/icons-material';

export const DeleteModal = ({ deleteModal , setDeleteModal , item , ticketApi }) => {
	const [comment , setComment] = useState('');

	const deleteTicket = (ticketId) => {
    ApiService.post(`/tickets/checklists/delete` , {
			"ticket_id" : ticketId , 
			"comment" : comment
		})
      .then((data) => {
				setDeleteModal(false)
        toast.success(data?.message)
				ticketApi()
      })
      .catch((error) => {
				setDeleteModal(false)
        toast.error(error?.data?.message)
      });
  }


	return (
		<Paper elevation={0}>
			<div style={{ color: '#555555' }}>
					Are you sure to delete this Ticket ? 
				</div>
				<Row>
					<Col md={12}>
						<TextField
							className="mt-3"
							color="secondary"
							variant="outlined"
							placeholder="Add a comment..."
							multiline
							fullWidth
							value={comment}
							onChange={(e) => setComment(e.target.value)}
							inputProps={{ maxLength: 256 }}
							sx={{
								'& .MuiInputBase-root': {
									fontSize: '14px',
									backgroundColor: '#f9f9f9',
									borderRadius: '8px',
									height: '100px',
									alignItems: 'flex-start', 
								},
								'& .MuiOutlinedInput-notchedOutline': {
									borderColor: '#ccc',
								},
								'&:hover .MuiOutlinedInput-notchedOutline': {
									borderColor: '#999',
								},
								'&.Mui-focused .MuiOutlinedInput-notchedOutline': {
									borderColor: '#3f51b5',
								},
							}}
						/>
					</Col>
				</Row>
				<Row>
					<Col md='auto'>
						<ButtonTheme type='submit' variant="filled" color='white' className='mt-4' onClick={() => setDeleteModal(false)}>
							Cancel
						</ButtonTheme>
					</Col>
					<Col md='auto'>
						<ButtonTheme type='submit' variant="filled" color='primary' className='mt-4' onClick={() => deleteTicket(item?.id)}>
							Delete
						</ButtonTheme>
					</Col>
				</Row>
		</Paper>
	)
}

export const EditModal = ({ editModal , setEditModal , item , ticketApi , editId }) => {
	const [title, setTitle] = useState('');
	const [description, setDescription] = useState('');
	const [hovered, setHovered] = useState(false);
	const [image, setImage] = useState(null);
	const [secondaryImage, setSecondaryImage] = useState(null);
	const [imagePreview, setImagePreview] = useState(null);
	const [secondaryImagePreview, setSecondaryImagePreview] = useState(null);

	const getTicketDetails = (id) => {
		ApiService.get(`/tickets/checklists/edit/${id}`)
			.then((res) => {
				const ticket = res?.data?.data;
				setTitle(ticket?.title || '');
				setDescription(ticket?.description || '');
				setImage(ticket?.image || '');
				setSecondaryImage(ticket?.secondary_image || '');
			})
			.catch((error) => {
				toast.error(error?.data?.message);
			});
	};

	useEffect(()=>{
		getTicketDetails(editId)
	}, [])

	const removeImage = (type) => {
		if (type === 'primary') {
			setImage(null);
			setImagePreview(null);
		} else if (type === 'secondary') {
			setSecondaryImage(null);
			setSecondaryImagePreview(null);
		}
	};

	const handleImageChange = (event, type) => {
		const file = event.target.files?.[0];
		if (file) {
			const previewUrl = URL.createObjectURL(file);

			if (type === 'primary') {
				setImage(file);                   
				setImagePreview(previewUrl);
			} else if (type === 'secondary') {
				setSecondaryImage(file);        
				setSecondaryImagePreview(previewUrl);
			}
		}
	};

	const convertToBase64 = async (input) => {
		if (typeof input === 'string') {
			const res = await fetch(input);
			const blob = await res.blob();
			return new Promise((resolve, reject) => {
				const reader = new FileReader();
				reader.readAsDataURL(blob);
				reader.onload = () => resolve(reader.result);
				reader.onerror = (error) => reject(error);
			});
		} else if (input instanceof File) {
			return new Promise((resolve, reject) => {
				const reader = new FileReader();
				reader.readAsDataURL(input);
				reader.onload = () => resolve(reader.result);
				reader.onerror = (error) => reject(error);
			});
		}
	};

	const updateTicket = async (id) => {
		const formData = new FormData();
		formData.append('ticket_id', id);
		formData.append('title', title);
		formData.append('description', description);
		formData.append('type', 'base64');

		if (image) {
			const base64Image = await convertToBase64(image);
			formData.append('image', base64Image);
		}

		if (secondaryImage) {
			const base64Secondary = await convertToBase64(secondaryImage);
			formData.append('secondary_image', base64Secondary);
		}

		ApiService.post(`/tickets/checklists/update`, formData)
			.then((res) => {
				toast.success(res?.message || 'Updated successfully');
				setEditModal(false);
				ticketApi();
			})
			.catch((err) => {
				toast.error(err?.data?.message || 'Update failed');
			});
	};

	return (
		<Paper elevation={0} className='px-2'>
				<Row className="mb-2">
					<Col md={12}>
						<label className="mb-1" style={{ fontSize: '14px', fontWeight: 500 }}>Title</label>
						<TextField
							color="secondary"
							variant="outlined"
							placeholder="Enter title"
							fullWidth
							value={title}
							onChange={(e) => setTitle(e.target.value)}
							sx={{
								'& .MuiInputBase-root': {
									fontSize: '14px',
									borderRadius: '8px',
								},
								'& .MuiOutlinedInput-notchedOutline': {
									borderColor: '#ccc',
								},
								'&:hover .MuiOutlinedInput-notchedOutline': {
									borderColor: '#999',
								},
								'&.Mui-focused .MuiOutlinedInput-notchedOutline': {
									borderColor: '#3f51b5',
								},
							}}
						/>
					</Col>
				</Row>

				<Row className="mb-2">
					<Col md={12}>
						<label className="mb-1" style={{ fontSize: '14px', fontWeight: 500 }}>Description</label>
						<TextField
							className='mt-1 w-100'
							multiline
							color='secondary'
							variant="outlined"
							value={description}
							placeholder="Type message here..."
							sx={{
									"& .MuiInputBase-root": {
											minHeight: '87px'
									},
									"& .MuiInputBase-input": {
											alignSelf: 'flex-start'
									}
							}}
							onChange={(e) => setDescription(e.target.value)}
					/>
					</Col>
				</Row>

				<Row className="mb-2">
					<Col md={3}>
						<label className="mb-1" style={{ fontSize: '14px', fontWeight: 500 }}>Primary Image</label>
						<Box
							position="relative"
							width="80px"
							height="80px"
							mt={1}
							onMouseEnter={() => setHovered('primary')}
							onMouseLeave={() => setHovered(null)}
							sx={{
								border: '1px solid #ccc',
								borderRadius: '16px',
								backgroundColor: '#f5f5f5',
								overflow: 'hidden',
								cursor: 'pointer',
							}}
						>
							{image ? (
								<>
									<img
										src={imagePreview || image}
										alt="Primary"
										style={{
											width: '100%',
											height: '100%',
											objectFit: 'cover',
											pointerEvents: 'none',
											userSelect: 'none',
										}}
									/>
									<IconButton
										size="small"
										onClick={() => removeImage('primary')}
										sx={{
											position: 'absolute',
											top: 2,
											right: 2,
											padding:'2px',
											backgroundColor: '#555555',
											color:'#f5f5f5',
											zIndex: 1,
											'&:hover': { backgroundColor: '#333333' },
										}}
									>
										<Close fontSize="small" />
									</IconButton>
								</>
							) : (
								<Box position="absolute" top="50%" left="50%" sx={{ transform: 'translate(-50%, -50%)' }}>
									<IconButton component="label" sx={{ backgroundColor: '#ffffffdd' }}>
										<PhotoCamera />
										<input
											type="file"
											accept="image/*"
											hidden
											onChange={(e) => handleImageChange(e, 'primary')}
										/>
									</IconButton>
								</Box>
							)}
						</Box>
					</Col>

					<Col md={4}>
						<label className="mb-1" style={{ fontSize: '14px', fontWeight: 500 }}>Secondary Image</label>
						<Box
							position="relative"
							width="80px"
							height="80px"
							mt={1}
							onMouseEnter={() => setHovered('secondary')}
							onMouseLeave={() => setHovered(null)}
							sx={{
								border: '1px solid #ccc',
								borderRadius: '16px',
								backgroundColor: '#f5f5f5',
								overflow: 'hidden',
								cursor: 'pointer',
							}}
						>
							{secondaryImage ? (
								<>
									<img
										src={secondaryImagePreview || secondaryImage}
										alt="Secondary"
										style={{
											width: '100%',
											height: '100%',
											objectFit: 'cover',
											pointerEvents: 'none',
											userSelect: 'none',
										}}
									/>
									<IconButton
										size="small"
										onClick={() => removeImage('secondary')}
										sx={{
											position: 'absolute',
											top: 2,
											right: 2,
											padding:'2px',
											backgroundColor: '#555555',
											color:'#f5f5f5',
											zIndex: 1,
											'&:hover': { backgroundColor: '#333333' },
										}}
									>
										<Close fontSize="small" />
									</IconButton>
								</>
							) : (
								<Box position="absolute" top="50%" left="50%" sx={{ transform: 'translate(-50%, -50%)' }}>
									<IconButton component="label" sx={{ backgroundColor: '#ffffffdd' }}>
										<PhotoCamera />
										<input
											type="file"
											accept="image/*"
											hidden
											onChange={(e) => handleImageChange(e, 'secondary')}
										/>
									</IconButton>
								</Box>
							)}
						</Box>
					</Col>
				</Row>

				<Row>
					<Col md='auto'>
						<ButtonTheme type='submit' variant="filled" color='white' className='mt-4' onClick={() => setEditModal(false)}>
							Cancel
						</ButtonTheme>
					</Col>
					<Col md='auto'>
						<ButtonTheme type='submit' variant="filled" color='primary' className='mt-4' onClick={() => updateTicket(editId)}>
							Save
						</ButtonTheme>
					</Col>
				</Row>
		</Paper>
	)
}

